<template>
  <section class="cancel-reason-page">
    <cancel-reason :reasons="reasons" @reasonSelected="reasonSelected" />
    <template v-if="hasReason">
      <cta-button
        type="button"
        class="button"
        :loading="isLoading"
        @click="cancelSubscription()"
        >Yes, continue with cancellation</cta-button
      >
      <cta-button
        type="button"
        class="button"
        :disabled="isLoading"
        @click="navToSubscriptionPage()"
        >Keep my subscription</cta-button
      >
    </template>
  </section>
</template>

<script>
import CancelReason from "@/components/CancelReason";
import CtaButton from "@/components/CtaButton";

export default {
  name: "CancelReasonPage",
  components: {
    CancelReason,
    CtaButton,
  },
  data() {
    return {
      isLoading: false,
      error: null,
      reasons: [
        "My partner stopped using it",
        "It costs too much",
        "I wasn't using it enough",
        "Technical issues",
      ],
      selectedReasons: null,
    };
  },
  computed: {
    hasReason() {
      return this.selectedReasons && this.selectedReasons.length;
    },
  },
  methods: {
    reasonSelected(reason) {
      this.selectedReasons = reason;
    },
    cancelSubscription() {
      this.error = null;
      this.isLoading = true;
      this.$tracker.trackCancelReasonSelected({
        question: "Why are you thinking of cancelling?",
        answer: this.selectedReasons,
      });
      this.$router.push({ name: "cancelValue" });
    },
    navToSubscriptionPage() {
      this.$router.push({ name: "subscription" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins";
@import "@/style/variables.scss";

.cancel-reason-page {
}
</style>
